"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1185],{

/***/ 51185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ ButtonWithLoader; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/indicator/InnerIndicator.tsx




var _templateObject;

var _excluded = ["styles", "isLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var InnerIndicatorComponent = function InnerIndicatorComponent(props) {
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      isLoading = props.isLoading,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var exBlockStyle = styles.exBlockStyle;

  if (!isLoading) {
    return null;
  }

  var blockStyles = /*#__PURE__*/(0,emotion_react_browser_esm.css)([blockStyle, exBlockStyle],  true ? "" : 0,  true ? "" : 0);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread(_objectSpread({
    css: blockStyles
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: loaderStyle,
      children: "Loading..."
    })
  }));
};

var InnerIndicator = /*#__PURE__*/react.memo(InnerIndicatorComponent);
var zIndex = 99999;
var spin = (0,emotion_react_browser_esm.keyframes)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;z-index:", zIndex, ";top:50%;left:50%;transform:translate(-50%, -50%);" + ( true ? "" : 0),  true ? "" : 0);
var loaderStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:0.75rem;height:0.75rem;border-radius:50%;text-indent:100%;white-space:nowrap;overflow:hidden;border-top:0.75rem solid rgba(255, 255, 255, 0.5);border-right:0.75rem solid rgba(255, 255, 255, 0.5);border-bottom:0.75rem solid rgba(255, 255, 255, 0.5);border-left:0.75rem solid #fffffe;animation-name:", spin, ";animation-duration:1.2s;animation-iteration-count:infinite;animation-timing-function:linear;box-sizing:border-box;&:after{width:0.75rem;height:0.75rem;border-radius:50%;}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx


var ButtonWithLoader_excluded = ["styles", "buttonType", "children", "isLoading"];

function ButtonWithLoader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ButtonWithLoader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ButtonWithLoader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ButtonWithLoader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var ButtonWithLoaderComponent = function ButtonWithLoaderComponent(props) {
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      buttonType = props.buttonType,
      children = props.children,
      isLoading = props.isLoading,
      rest = (0,objectWithoutProperties/* default */.Z)(props, ButtonWithLoader_excluded);

  var buttonTypeStyle;

  switch (buttonType) {
    case "buttonSmall":
      buttonTypeStyle = buttonSmallStyle;
      break;

    default:
      buttonTypeStyle = buttonStyle;
  }

  var exBlockStyle = styles.exBlockStyle,
      exButtonStyle = styles.exButtonStyle; // スタイル文字列の切り替えを動的に行うとemotionでwarningが発生するため、
  // Stateによる切り替え部分はコンポーネント内部で定義する

  var loadingTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)(textStyle, ";transform:translateX(", isLoading ? "-1rem" : 0, ");" + ( true ? "" : 0),  true ? "" : 0);
  var buttonWithLoaderStyles = isLoading ? /*#__PURE__*/(0,emotion_react_browser_esm.css)(buttonWithLoaderStyle, ";&:disabled{opacity:1;}" + ( true ? "" : 0),  true ? "" : 0) : buttonWithLoaderStyle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: [ButtonWithLoader_blockStyle, exBlockStyle,  true ? "" : 0,  true ? "" : 0],
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", ButtonWithLoader_objectSpread(ButtonWithLoader_objectSpread({
      css: [buttonTypeStyle, buttonWithLoaderStyles, exButtonStyle,  true ? "" : 0,  true ? "" : 0]
    }, rest), {}, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: loadingTextStyle,
        children: children
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InnerIndicator, {
        isLoading: isLoading,
        styles: {
          exBlockStyle: loaderBlockStyle
        }
      })]
    }))
  });
};

var ButtonWithLoader = /*#__PURE__*/react.memo(ButtonWithLoaderComponent);
var ButtonWithLoader_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:", typographyStyle/* fontWeight.regular */.Ue.regular, ";color:white;background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";padding:0 ", spaceStyle/* space.atom */.D.atom, ";border:none;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";margin:0;width:100%;min-width:64px;height:40px;line-height:40px;box-sizing:border-box;overflow:hidden;text-align:center;outline:none;cursor:pointer;text-decoration:none;letter-spacing:0.1em;transition:background 0.4s ease,opacity 0.4s ease;&:hover{background-color:", colorStyle/* accentColor.primaryDarkColor */.z.primaryDarkColor, ";}&:disabled{opacity:0.5;cursor:default;&:hover{background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";}}", (0,responsiveStyle/* minResolution */.UW)("scale2x"), ":{font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonSmallStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.regular */.Ue.regular, ";color:white;background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";padding:0 ", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";border:none;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";margin:0;width:100%;min-width:64px;height:36px;line-height:36px;box-sizing:border-box;overflow:hidden;text-align:center;outline:none;cursor:pointer;text-decoration:none;letter-spacing:0.1em;transition:background 0.4s ease,opacity 0.4s ease;&:hover{background-color:", colorStyle/* accentColor.primaryDarkColor */.z.primaryDarkColor, ";}&:disabled{opacity:0.5;cursor:default;&:hover{background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";}}", (0,responsiveStyle/* minResolution */.UW)("scale2x"), "{font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";}" + ( true ? "" : 0),  true ? "" : 0);
var loaderBlockStyle =  true ? {
  name: "19ymzw6",
  styles: "left:auto;right:0.5rem;transform:translate(0, -50%)"
} : 0;
var buttonWithLoaderStyle =  true ? {
  name: "1t0too1",
  styles: "padding:0 1.5rem;position:relative;min-width:80px"
} : 0;
var textStyle =  true ? {
  name: "1574z7m",
  styles: "display:block;transition:transform 0.4s ease;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : 0;

/***/ })

}]);